import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const handleSubscribe = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const email = formData.get('email_address');
    
    // TODO: Implement newsletter subscription
    console.log('Subscribe email:', email);
  };

  return (
    <footer
      className="footer section has-bg-image text-center"
      style={{ backgroundImage: "url('/assets/images/footer-bg.jpg')" }}
    >
      <div className="container">
        <div className="footer-top grid-list">
          <div className="footer-brand has-before has-after">
            <Link to="/" className="logo">
              <img
                src="/assets/images/logo.png"
                width="240"
                height="75"
                loading="lazy"
                alt="Happy Valley Village home"
              />
            </Link>

            <p className="body-4" style={{ textAlign: 'left', marginBlock: '15px' }}>
              A top-rated Chinese restaurant in Hacienda Heights, CA offering a wide range of
              delicious Chinese dishes. Happy Valley Village provides a casual dining experience
              with many vegetarian options, wheelchair accessibility, and happy hour specials. Call
              (626) 363-7268 to make a reservation or order for delivery or takeout.
            </p>

            <address className="body-4" style={{ textAlign: 'left', marginBlock: '15px' }}>
              Address: 1655 S Azusa Ave Ste E Hacienda Heights, CA 91745
            </address>

            <p className="body-4" style={{ textAlign: 'left', marginBlockEnd: '15px' }}>
              Hotline:{' '}
              <a href="tel:+16263637268" className="hover-underline">
                (626) 363-7268
              </a>
            </p>

            <div className="footer-map" style={{ marginBlock: '30px' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3306.1234567890123!2d-117.9334786!3d33.9921005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2d5ac2590537d%3A0xd8705b352115d687!2sHappy%20Valley%20Village%2F%20Shanlitun!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                width="100%"
                height="300"
                style={{ border: 0, borderRadius: '12px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className="wrapper">
              <div className="separator"></div>
              <div className="separator"></div>
              <div className="separator"></div>
            </div>

            <p className="title-1">Get News & Offers</p>

            <p className="label-1">
              Subscribe us & Get <span className="span">25% Off.</span>
            </p>

            <form onSubmit={handleSubscribe} className="input-wrapper">
              <div className="icon-wrapper">
                <ion-icon name="mail-outline" aria-hidden="true"></ion-icon>
                <input
                  type="email"
                  name="email_address"
                  placeholder="Your email"
                  autoComplete="off"
                  className="input-field"
                  required
                />
              </div>

              <button type="submit" className="btn btn-secondary">
                <span className="text text-1">Subscribe</span>
                <span className="text text-2" aria-hidden="true">
                  Subscribe
                </span>
              </button>
            </form>
          </div>

          <ul className="footer-list">
            <li>
              <Link to="/#home" className="label-2 footer-link hover-underline">
                Home
              </Link>
            </li>
            <li>
              <Link to="/#menu" className="label-2 footer-link hover-underline">
                Menus
              </Link>
            </li>
            <li>
              <Link to="/#about" className="label-2 footer-link hover-underline">
                About Us
              </Link>
            </li>
            <li>
              <a href="#" className="label-2 footer-link hover-underline">
                Our Chefs
              </a>
            </li>
            <li>
              <Link to="/review" className="label-2 footer-link hover-underline">
                Review
              </Link>
            </li>
            <li>
              <Link to="/contact" className="label-2 footer-link hover-underline">
                Contact
              </Link>
            </li>
          </ul>

          <ul className="footer-list">
            <li>
              <a
                href="https://www.facebook.com/HVVLA/"
                className="label-2 footer-link hover-underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
            <li>
              <a href="#" className="label-2 footer-link hover-underline">
                Instagram
              </a>
            </li>
            <li>
              <a href="#" className="label-2 footer-link hover-underline">
                Twitter
              </a>
            </li>
            <li>
              <a href="#" className="label-2 footer-link hover-underline">
                Youtube
              </a>
            </li>
            <li>
              <a
                href="https://www.google.com/maps/place/Happy+Valley+Village%2F+Shanlitun/@33.9921004,-117.9383495,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2d5ac2590537d:0xd8705b352115d687!8m2!3d33.9921005!4d-117.9334786!16s%2Fg%2F11h5n7mc3b?hl=en-US&entry=ttu&g_ep=EgoyMDI1MTEwMi4wIKXMDSoASAFQAw%3D%3D"
                className="label-2 footer-link hover-underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Map
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-bottom">
          <p className="copyright">&copy; 2025 Happy Valley Village. All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
